<script>
	import { Router, Link, Route } from "svelte-routing";
	import Produce from "./routes/Produce.svelte";
	import ProduceDetail from "./routes/ProduceDetail.svelte";
	import RecipeDetail from "./routes/RecipeDetail.svelte";
	import Recipes from "./routes/Recipes.svelte";
	import { recipes, isLoggedIn, loadProduce, isReady } from "./stores";

	export let url = "";
	let promise = (async () => {
		let result = await fetch("/api/recipe");
		recipes.set(await result.json());

		await loadProduce();
	})();

	let username;
	let password;

	const checkStatus = async () => {
		try {
			let statusResponse = await fetch("/api/status");
			let statusJson = await statusResponse.json();
			$isLoggedIn = !!statusJson.username;
		} catch (e) {
			$isLoggedIn = false;
		}

		$isReady = true;
	};

	checkStatus();

	const logout = async () => {
		await fetch("/api/logout");
		checkStatus();
	};

	const login = async () => {
		await fetch("/api/login", {
			method: "POST",
			headers: {
				"content-type": "application/json",
			},
			body: JSON.stringify({
				username,
				password,
			}),
		});

		checkStatus();
	};
</script>

<div class="cover">
	<Router {url}>
		<nav class="with-sidebar">
			<div class="not-sidebar">
				<Link to="recipes">Recipes</Link>
				<Link to="new-recipe">New Recipes</Link>
				<Link to="produce">Produce</Link>
				<Link to="new-produce">New produce</Link>
			</div>
			<div class="sidebar">
				<a on:click|preventDefault={() => logout()} href="/">Logout</a>
			</div>
		</nav>

		{#if $isReady}
			{#if $isLoggedIn}
				<div class="stack">
					{#await promise then}
						<Route path="recipes" component={Recipes} />
						<Route path="recipes/:slug" component={RecipeDetail} />
						<Route
							path="new-recipe"
							component={RecipeDetail}
							newrecipe={true}
						/>
						<Route path="produce" component={Produce} />
						<Route path="produce/:slug" component={ProduceDetail} />
						<Route
							path="new-produce"
							component={ProduceDetail}
							newprod={true}
						/>
					{/await}
				</div>
			{:else}
				<div class="stack">
					<h2>Please login first</h2>
					<input
						type="text"
						placeholder="username"
						bind:value={username}
					/>
					<input type="password" bind:value={password} />
					<button on:click={login}>Login</button>
				</div>
			{/if}
		{/if}
	</Router>
</div>
